<template>
  <ContentBlock class="team-view">
    <template v-if="team">
      <TeamViewHeader />
      <TeamViewRoster />
    </template>
    <p class="team-view__message" v-else-if="loading">Загрузка...</p>
    <p class="team-view__message" v-else>Команда не создана</p>
  </ContentBlock>
</template>

<script>
import TeamViewHeader from "./TeamViewHeader";
import TeamViewRoster from "./TeamViewRoster";
import { mapActions, mapState, mapMutations } from "vuex";
import { asyncModal } from "@/components/ui/modal/";

const TeamView = {
  name: "TeamView",
  props: {
    otherTeam: Object
  },
  components: {
    TeamViewHeader,
    TeamViewRoster
  },
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapState("team", ["team"])
  },
  created() {
    if (this.otherTeam) {
      this.setTeam(this.otherTeam);
    } else {
      this.getTeam();
    }
  },
  destroyed() {
    this.clear();
  },
  methods: {
    ...mapMutations("team", ["clear", "setTeam"]),
    ...mapActions("team", ["fetchTeam"]),
    async getTeam() {
      this.loading = true;
      await this.fetchTeam();
      this.loading = false;
      this.$emit("loaded");
    }
  }
};

export default TeamView;

export function openModal(team) {
  return asyncModal({
    name: "team-view-modal",
    component: TeamView,
    props: {
      otherTeam: team
    }
  });
}
</script>

<style lang="scss">
.team-view {
  padding: 50px;

  @include breakpoint("md-and-down") {
    padding: 25px;
  }

  @include breakpoint("sm-and-down") {
    padding: 15px;
  }

  &__message {
    color: colors(text-2);
    text-align: center;
    font-size: 22px;
    font-weight: fw(bold);
  }

  .team-view-modal & {
    padding: 20px;
  }
}
</style>
